import { readCosmosDiagnostics } from '@/diagnosticsState';

export function reportEpisodeDiagnostic(event: string, detail: () => Record<string, unknown>): void {
    if (typeof window === 'undefined' || !readCosmosDiagnostics().episode) return;
    const entry = { event, wallTimeMs: performance.now(), ...detail() };
    console.debug('[episode-diagnostics]', entry);
    window.dispatchEvent(new CustomEvent('episode-diagnostic', { detail: entry }));
}
